import { render, staticRenderFns } from "./HaiBoTangOrderAppraisals.vue?vue&type=template&id=03d732b6&scoped=true"
import script from "./HaiBoTangOrderAppraisals.vue?vue&type=script&lang=js"
export * from "./HaiBoTangOrderAppraisals.vue?vue&type=script&lang=js"
import style0 from "./HaiBoTangOrderAppraisals.vue?vue&type=style&index=0&id=03d732b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d732b6",
  null
  
)

export default component.exports